import type {
  ApplicationResourceReadV2Api,
  SystemPackageResourceReadV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import type { ApplicationOrSystemPackageResourceSearchFront } from '@ingenico/react-configuration-generator';
import { toString } from 'lodash-es';

export function mapApplicationListResponseApiOSystemPackageListResponseApi(
  data: ApplicationResourceReadV2Api[] | SystemPackageResourceReadV2Api[],
): ApplicationOrSystemPackageResourceSearchFront[] {
  return data.reduce(
    (
      acc: ApplicationOrSystemPackageResourceSearchFront[],
      item: ApplicationResourceReadV2Api | SystemPackageResourceReadV2Api,
    ) => {
      if (item.id) {
        acc.push({
          id: item.id,
          logoAsset: item.assets.find((asset) => ['IMAGE', 'LOGO'].includes(toString(asset.type))) ?? undefined,
          name: toString(item.name),
          compatibleDeviceFamilyNames: item.compatibleDeviceFamilyNames ?? [],
        });
      }
      return acc;
    },
    [] as ApplicationOrSystemPackageResourceSearchFront[],
  );
}
